module.exports = "../../app/cells/pages/bifrost/study_guide/card_info_cell.rb";